import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';  // Create a simple one if needed
import CandidatesPage from './pages/CandidatesPage';
import CommitteesPage from './pages/CommitteesPage';
import ContributionsPage from './pages/ContributionsPage';
import CandidateNavPage from './pages/CandidateNavPage';
import AdminLogin from './pages/admin/Login';
import AdminIndex from './pages/admin/Index';
import CandidatesAdmin from './pages/admin/Candidates';
import CandidateEdit from './pages/admin/CandidateEdit';
import CommitteesAdmin from './pages/admin/Committees';
import CommitteeEdit from './pages/admin/CommitteeEdit';
import SolicitationsAdmin from './pages/admin/Solicitations';
import VotersAdmin from './pages/admin/Voters';
import VoterDetails from './pages/admin/VoterDetails';
import CandidateDetail from './components/CandidateDetail';  // New import
import CommitteeDetail from './components/CommitteeDetail';  // New import
import GA from './components/GA';
import DocumentsPage from './pages/DocumentsPage';

function App() {
  return (
    <Router>  {/* Wraps your app in router */}
      <GA />
      <div className="App">
        <Routes>  {/* Defines page routes */}
          <Route path="/candidates/:electionId/:officeCode" element={<CandidateNavPage />} />
          <Route path="/candidates/:acctNum" element={<CandidateDetail />} />
          <Route path="/committees/:acctNum" element={<CommitteeDetail />} />
          <Route path="/candidates" element={<CandidatesPage />} /> 
          <Route path="/committees" element={<CommitteesPage />} /> 
          <Route path="/contributions" element={<ContributionsPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminIndex />} />
          <Route path="/admin/candidates" element={<CandidatesAdmin />} />
          <Route path="/admin/candidates/edit/:acctNum" element={<CandidateEdit />} />
          <Route path="/admin/committees" element={<CommitteesAdmin />} />
          <Route path="/admin/committees/edit/:acctNum" element={<CommitteeEdit />} />
          <Route path="/admin/solicitations" element={<SolicitationsAdmin />} />
          <Route path="/admin/voters" element={<VotersAdmin />} />
          <Route path="/admin/voters/:voterId" element={<VoterDetails />} />
          <Route path="/documents/recent" element={<DocumentsPage />} />
          <Route path="/" element={<HomePage />} />
          {/* Add more: <Route path="/elections" element={<ElectionsPage />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
